<template>
    <swiper class="swiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in swiperImg" :key="index">
            <img :src="item" alt="">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
    name: 'Home',
    props: {
        swiperImg: Object,
    },
    title: 'Pagination',
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            swiperOption: {
                spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                autoplay: true
            },
        }
    }
}
</script>
<style lang="less" scoped>
.swiper {
    height: 100%;
    width: 100%;
    border: 1px transparent solid;

    .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-weight: bold;
        font-size: 14px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .swiper-pagination {
        bottom: 80px;
    }
}
</style>